import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Loader from '../../components/loader';

function App() {
  const [reciepts, setReciepts] = useState([]);
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [loading, setLoading] = useState(false);
  

  const months = Array.from({ length: 12 }, (_, i) =>
    new Date(0, i).toLocaleString("default", { month: "long" })
  );

  const fetchDateData = async () => {
    setLoading(true);
    const sendData = {
      year: year,
      month: month
    };
    try {
      const response = await axios.post('https://api.trucoo.in/ledger/cd-note/', sendData, {
        headers: {
          'Content-Type': 'application/json',
          'X-API-KEY': 'erpTrucoo'
      }});

    //   console.log(response?.data);

      if(response?.data?.status === 'success'){
        setReciepts(response?.data?.data);
      }else{
        setReciepts([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDateData();
  }, [year, month]);

  const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
 };

  let debitTotalValue = 0;
  let creditTotalValue = 0;

  return (
    <>
     {loading && <Loader />}
      <Header />
      <Sidebar />
      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="col-12">
              <div className="box">
                <div className="box-header with-border">
                   <h4 className="box-title">Credit/Debit Notes</h4>
                   <div className="box-tools pull-right">
                    <div className='flex gap-2'>
                      {/* <p className='mt-2' style={{minWidth: '400px'}}>Payment for {year} {month && month !== 'all' ? new Date(0, month - 1).toLocaleString("default", { month: "long" }) : ''} is <span className='text-bold'>{Number(totalAmount).toFixed(2)}</span></p> */}
                      <select value={year} onChange={(e) => setYear(e.target.value)} className='form-select' style={{minWidth: '90px'}}>
                        <option value="all">All Years</option>
                        {Array.from(
                          { length: currentYear - 2023 + 1 },
                          (_, i) => currentYear - i
                        ).map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}

                      </select>
                      {year !== 'all' && (
                        <select value={month} onChange={(e) => setMonth(Number(e.target.value))} className='form-select' style={{minWidth: '120px'}}>
                          <option value="all">All Months</option>
                          {months.map((month, index) => (
                            <option key={index} value={index + 1}>
                              {month}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                   </div>
                </div>
                <div className="box-body">
                  
                  <div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 230px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                    <table className="table-sm fs-12 text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                      <thead>
                         <tr className="text-dark text-center" style={{ position: 'sticky', top: -1, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                          <th className='text-center'>S.No</th>
                          <th className='text-center'>Date</th>
                          <th className='text-center'>Code</th>
                          <th>Party</th>
                          <th>Ledger</th>
                          <th className='text-end'>Debit Note</th>
                          <th className='text-end'>Credit Note</th>
                          <th className='text-end'>Note</th>
                        </tr>
                      </thead>
                      <tbody>
                          {reciepts?.length > 0 ?
                            reciepts?.map((payment, index) => {
                                const debitTotal = payment?.type === 'debit' ? parseFloat(payment?.amount || 0) : 0;
                                const creditTotal = payment?.type === 'credit' ? parseFloat(payment?.amount || 0) : 0;
                                creditTotalValue += creditTotal;
                                debitTotalValue += debitTotal;
                              return (
                              <tr key={index}>
                                <td className='text-center'>{index + 1}</td>
                                <td className='text-center'>{formatViewDate(payment?.date)}</td>
                                <td className='text-center'>{payment?.partyCode}</td>
                                <td>{payment?.partyName}</td>
                                <td>{payment?.subGroupName}</td>
                                <td className='text-end'>{Number(debitTotal).toFixed(2)}</td>
                                <td className='text-end'>{Number(creditTotal).toFixed(2)}</td>
                                <td className='text-end'>{payment?.note}</td>
                              </tr>
                            )})
                          :
                            <tr>
                              <td colSpan="9" className="text-center">No records found</td>
                            </tr>
                        }
                        <tr
                          className="text-dark"
                          style={{
                            position: "sticky",
                            bottom: -11,
                            zIndex: 2,
                            backgroundColor: "#f8f9fa",
                          }}
                        >
                          <th colSpan={5}>Total</th>
                        
                          <th className="text-end">{new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            }).format(debitTotalValue)}
                          </th>
                          <th className="text-end">{new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            }).format(creditTotalValue)}
                          </th>
                          <th></th>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default App;
